module.exports = __webpack_public_path__ + "img/semicircle.400ed632.png";